(function () {
  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function selectedOptions(root) {
    var opts = [];
    root.querySelectorAll('[data-option-index]').forEach(function (fieldset) {
      var checked = fieldset.querySelector('[data-option-input]:checked');
      opts.push(checked ? checked.value : null);
    });
    return opts;
  }

  function findVariant(variants, opts) {
    var keys = ['option1', 'option2', 'option3'];
    return variants.filter(function (variant) {
      return keys.every(function (key, i) {
        return opts[i] == null || variant[key] === opts[i];
      });
    })[0];
  }

  function initProductForm(root) {
    var jsonEl = root.querySelector('[data-product-json]');
    var variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    var variantIdInput = root.querySelector('[data-variant-id-input]');
    var priceEl = root.querySelector('[data-price]');
    var comparePriceEl = root.querySelector('[data-compare-price]');
    var availabilityEl = root.querySelector('[data-availability-message]');
    var addButton = root.querySelector('[data-add-to-cart-button]');
    var mainImage = root.querySelector('[data-main-media] img');

    function updateUI() {
      var variant = findVariant(variants, selectedOptions(root));

      if (!variant) {
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = addButton.getAttribute('data-label-unavailable') || addButton.textContent;
        }
        if (availabilityEl) availabilityEl.textContent = availabilityEl.getAttribute('data-unavailable-text') || '';
        return;
      }

      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);

      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }

      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available
          ? addButton.getAttribute('data-label-add')
          : addButton.getAttribute('data-label-sold-out');
      }

      if (availabilityEl) {
        availabilityEl.textContent = variant.available
          ? availabilityEl.getAttribute('data-in-stock-text')
          : availabilityEl.getAttribute('data-sold-out-text');
        availabilityEl.classList.toggle('is-sold-out', !variant.available);
      }

      if (mainImage && variant.featured_image && variant.featured_image.src) {
        mainImage.src = variant.featured_image.src;
      }
    }

    root.querySelectorAll('[data-option-input]').forEach(function (input) {
      input.addEventListener('change', updateUI);
    });

    root.querySelectorAll('[data-qty-minus], [data-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentElement.querySelector('[data-qty-input]');
        if (!input) return;
        var value = parseInt(input.value, 10) || 1;
        value = btn.hasAttribute('data-qty-minus') ? Math.max(1, value - 1) : value + 1;
        input.value = value;
      });
    });

    root.querySelectorAll('[data-media-select]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-image-url');
        if (mainImage && url) mainImage.src = url;
        root.querySelectorAll('[data-media-select]').forEach(function (b) {
          b.classList.remove('is-active');
        });
        btn.classList.add('is-active');
      });
    });

    updateUI();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-root]').forEach(initProductForm);
  });
})();
